<template>
  <router-view/>
</template>

 